/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './pages/__root'
import { Route as AuthlayoutRouteImport } from './pages/_authlayout'
import { Route as NoAuthRouteImport } from './pages/_no-auth'
import { Route as ChromeAppRouteImport } from './pages/chrome-app'
import { Route as AuthlayoutSpaceoverviewRouteRouteImport } from './pages/_authlayout/spaceoverview/route'
import { Route as NoAuthMinorsRouteImport } from './pages/_no-auth/minors'
import { Route as AuthlayoutSidebarIndexRouteImport } from './pages/_authlayout/_sidebar/index'
import { Route as AuthlayoutSidebarDashboardsRouteRouteImport } from './pages/_authlayout/_sidebar/dashboards/route'
import { Route as AuthlayoutSidebarDevicesRouteRouteImport } from './pages/_authlayout/_sidebar/devices/route'
import { Route as AuthlayoutSidebarThingsRouteRouteImport } from './pages/_authlayout/_sidebar/things/route'
import { Route as AuthlayoutSidebarTriggersRouteRouteImport } from './pages/_authlayout/_sidebar/triggers/route'
import { Route as NoAuthAuthFailedIndexRouteImport } from './pages/_no-auth/auth-failed/index'
import { Route as AuthlayoutHeaderDevicesIdRouteRouteImport } from './pages/_authlayout/_header/devices/$id/route'
import { Route as AuthlayoutHeaderTemplatesIdRouteRouteImport } from './pages/_authlayout/_header/templates/$id/route'
import { Route as AuthlayoutHeaderThingsIdRouteRouteImport } from './pages/_authlayout/_header/things/$id/route'
import { Route as AuthlayoutHeaderTriggersIdRouteRouteImport } from './pages/_authlayout/_header/triggers/$id/route'
import { Route as AuthlayoutNoneRegistrationIndexRouteImport } from './pages/_authlayout/_none/registration/index'
import { Route as AuthlayoutNoneTosAcceptanceIndexRouteImport } from './pages/_authlayout/_none/tos-acceptance/index'
import { Route as AuthlayoutSidebarApiKeysIndexRouteImport } from './pages/_authlayout/_sidebar/api-keys/index'
import { Route as AuthlayoutSidebarBrandingIndexRouteImport } from './pages/_authlayout/_sidebar/branding/index'
import { Route as AuthlayoutSidebarCoursesIndexRouteImport } from './pages/_authlayout/_sidebar/courses/index'
import { Route as AuthlayoutSidebarIntegrationsIndexRouteImport } from './pages/_authlayout/_sidebar/integrations/index'
import { Route as AuthlayoutSidebarMembersIndexRouteImport } from './pages/_authlayout/_sidebar/members/index'
import { Route as AuthlayoutSidebarPlanUsageIndexRouteImport } from './pages/_authlayout/_sidebar/plan-usage/index'
import { Route as AuthlayoutSidebarResourcesIndexRouteImport } from './pages/_authlayout/_sidebar/resources/index'
import { Route as AuthlayoutSidebarRolesPermissionsIndexRouteImport } from './pages/_authlayout/_sidebar/roles-permissions/index'
import { Route as AuthlayoutSidebarSettingsIndexRouteImport } from './pages/_authlayout/_sidebar/settings/index'
import { Route as AuthlayoutSidebarSketchesIndexRouteImport } from './pages/_authlayout/_sidebar/sketches/index'
import { Route as AuthlayoutSidebarTemplatesIndexRouteImport } from './pages/_authlayout/_sidebar/templates/index'
import { Route as AuthlayoutSidebarTrashIndexRouteImport } from './pages/_authlayout/_sidebar/trash/index'
import { Route as AuthlayoutSpaceoverviewDevicesIndexRouteImport } from './pages/_authlayout/spaceoverview/devices/index'
import { Route as AuthlayoutSpaceoverviewPlanusageIndexRouteImport } from './pages/_authlayout/spaceoverview/planusage/index'
import { Route as AuthlayoutSpaceoverviewStatisticsIndexRouteImport } from './pages/_authlayout/spaceoverview/statistics/index'
import { Route as AuthlayoutHeaderDevicesIdIndexRouteImport } from './pages/_authlayout/_header/devices/$id/index'
import { Route as AuthlayoutHeaderDevicesNewIndexRouteImport } from './pages/_authlayout/_header/devices/new/index'
import { Route as AuthlayoutHeaderTemplatesIdIndexRouteImport } from './pages/_authlayout/_header/templates/$id/index'
import { Route as AuthlayoutHeaderTemplatesNewIndexRouteImport } from './pages/_authlayout/_header/templates/new/index'
import { Route as AuthlayoutHeaderThingsIdIndexRouteImport } from './pages/_authlayout/_header/things/$id/index'
import { Route as AuthlayoutHeaderThingsNewIndexRouteImport } from './pages/_authlayout/_header/things/new/index'
import { Route as AuthlayoutHeaderTriggersNewIndexRouteImport } from './pages/_authlayout/_header/triggers/new/index'
import { Route as AuthlayoutHeaderDevicesIdFwupdateIndexRouteImport } from './pages/_authlayout/_header/devices/$id/fwupdate/index'
import { Route as AuthlayoutHeaderDevicesIdNetworkconfigIndexRouteImport } from './pages/_authlayout/_header/devices/$id/networkconfig/index'
import { Route as AuthlayoutHeaderTemplatesIdApplyIndexRouteImport } from './pages/_authlayout/_header/templates/$id/apply/index'
import { Route as AuthlayoutHeaderTemplatesIdEditIndexRouteImport } from './pages/_authlayout/_header/templates/$id/edit/index'
import { Route as AuthlayoutSidebarDashboardsSmartfolderIdIndexRouteImport } from './pages/_authlayout/_sidebar/dashboards/smartfolder/$id/index'
import { Route as AuthlayoutSidebarDevicesSmartfolderIdIndexRouteImport } from './pages/_authlayout/_sidebar/devices/smartfolder/$id/index'
import { Route as AuthlayoutSidebarThingsSmartfolderIdIndexRouteImport } from './pages/_authlayout/_sidebar/things/smartfolder/$id/index'
import { Route as AuthlayoutSidebarTriggersSmartfolderIdIndexRouteImport } from './pages/_authlayout/_sidebar/triggers/smartfolder/$id/index'

const AuthlayoutHeaderLazyRouteImport = createFileRoute(
  '/_authlayout/_header',
)()
const AuthlayoutNoneLazyRouteImport = createFileRoute('/_authlayout/_none')()
const AuthlayoutSidebarLazyRouteImport = createFileRoute(
  '/_authlayout/_sidebar',
)()
const AuthlayoutSidebarDashboardsIndexLazyRouteImport = createFileRoute(
  '/_authlayout/_sidebar/dashboards/',
)()
const AuthlayoutSidebarDevicesIndexLazyRouteImport = createFileRoute(
  '/_authlayout/_sidebar/devices/',
)()
const AuthlayoutSidebarThingsIndexLazyRouteImport = createFileRoute(
  '/_authlayout/_sidebar/things/',
)()
const AuthlayoutSidebarTriggersIndexLazyRouteImport = createFileRoute(
  '/_authlayout/_sidebar/triggers/',
)()
const AuthlayoutHeaderTriggersIdIndexLazyRouteImport = createFileRoute(
  '/_authlayout/_header/triggers/$id/',
)()

const AuthlayoutRoute = AuthlayoutRouteImport.update({
  id: '/_authlayout',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAuthRoute = NoAuthRouteImport.update({
  id: '/_no-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ChromeAppRoute = ChromeAppRouteImport.update({
  id: '/chrome-app',
  path: '/chrome-app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthlayoutHeaderLazyRoute = AuthlayoutHeaderLazyRouteImport.update({
  id: '/_header',
  getParentRoute: () => AuthlayoutRoute,
} as any).lazy(() =>
  import('./pages/_authlayout/_header.lazy').then((d) => d.Route),
)
const AuthlayoutNoneLazyRoute = AuthlayoutNoneLazyRouteImport.update({
  id: '/_none',
  getParentRoute: () => AuthlayoutRoute,
} as any).lazy(() =>
  import('./pages/_authlayout/_none.lazy').then((d) => d.Route),
)
const AuthlayoutSidebarLazyRoute = AuthlayoutSidebarLazyRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => AuthlayoutRoute,
} as any).lazy(() =>
  import('./pages/_authlayout/_sidebar.lazy').then((d) => d.Route),
)
const AuthlayoutSpaceoverviewRouteRoute =
  AuthlayoutSpaceoverviewRouteRouteImport.update({
    id: '/spaceoverview',
    path: '/spaceoverview',
    getParentRoute: () => AuthlayoutRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/spaceoverview/route.lazy').then((d) => d.Route),
  )
const NoAuthMinorsRoute = NoAuthMinorsRouteImport.update({
  id: '/minors',
  path: '/minors',
  getParentRoute: () => NoAuthRoute,
} as any)
const AuthlayoutSidebarIndexRoute = AuthlayoutSidebarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthlayoutSidebarLazyRoute,
} as any).lazy(() =>
  import('./pages/_authlayout/_sidebar/index.lazy').then((d) => d.Route),
)
const AuthlayoutSidebarDashboardsRouteRoute =
  AuthlayoutSidebarDashboardsRouteRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/dashboards/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarDevicesRouteRoute =
  AuthlayoutSidebarDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/devices/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarThingsRouteRoute =
  AuthlayoutSidebarThingsRouteRouteImport.update({
    id: '/things',
    path: '/things',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/things/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarTriggersRouteRoute =
  AuthlayoutSidebarTriggersRouteRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/triggers/route.lazy').then(
      (d) => d.Route,
    ),
  )
const NoAuthAuthFailedIndexRoute = NoAuthAuthFailedIndexRouteImport.update({
  id: '/auth-failed/',
  path: '/auth-failed/',
  getParentRoute: () => NoAuthRoute,
} as any).lazy(() =>
  import('./pages/_no-auth/auth-failed/index.lazy').then((d) => d.Route),
)
const AuthlayoutHeaderDevicesIdRouteRoute =
  AuthlayoutHeaderDevicesIdRouteRouteImport.update({
    id: '/devices/$id',
    path: '/devices/$id',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/devices/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTemplatesIdRouteRoute =
  AuthlayoutHeaderTemplatesIdRouteRouteImport.update({
    id: '/templates/$id',
    path: '/templates/$id',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/templates/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderThingsIdRouteRoute =
  AuthlayoutHeaderThingsIdRouteRouteImport.update({
    id: '/things/$id',
    path: '/things/$id',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/things/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTriggersIdRouteRoute =
  AuthlayoutHeaderTriggersIdRouteRouteImport.update({
    id: '/triggers/$id',
    path: '/triggers/$id',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/triggers/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutNoneRegistrationIndexRoute =
  AuthlayoutNoneRegistrationIndexRouteImport.update({
    id: '/registration/',
    path: '/registration/',
    getParentRoute: () => AuthlayoutNoneLazyRoute,
  } as any)
const AuthlayoutNoneTosAcceptanceIndexRoute =
  AuthlayoutNoneTosAcceptanceIndexRouteImport.update({
    id: '/tos-acceptance/',
    path: '/tos-acceptance/',
    getParentRoute: () => AuthlayoutNoneLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_none/tos-acceptance/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarApiKeysIndexRoute =
  AuthlayoutSidebarApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/api-keys/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarBrandingIndexRoute =
  AuthlayoutSidebarBrandingIndexRouteImport.update({
    id: '/branding/',
    path: '/branding/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/branding/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarCoursesIndexRoute =
  AuthlayoutSidebarCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/courses/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarDashboardsIndexLazyRoute =
  AuthlayoutSidebarDashboardsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutSidebarDashboardsRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarDevicesIndexLazyRoute =
  AuthlayoutSidebarDevicesIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutSidebarDevicesRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/devices/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarIntegrationsIndexRoute =
  AuthlayoutSidebarIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/integrations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarMembersIndexRoute =
  AuthlayoutSidebarMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/members/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarPlanUsageIndexRoute =
  AuthlayoutSidebarPlanUsageIndexRouteImport.update({
    id: '/plan-usage/',
    path: '/plan-usage/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/plan-usage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarResourcesIndexRoute =
  AuthlayoutSidebarResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/resources/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarRolesPermissionsIndexRoute =
  AuthlayoutSidebarRolesPermissionsIndexRouteImport.update({
    id: '/roles-permissions/',
    path: '/roles-permissions/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/roles-permissions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarSettingsIndexRoute =
  AuthlayoutSidebarSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarSketchesIndexRoute =
  AuthlayoutSidebarSketchesIndexRouteImport.update({
    id: '/sketches/',
    path: '/sketches/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/sketches/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarTemplatesIndexRoute =
  AuthlayoutSidebarTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarThingsIndexLazyRoute =
  AuthlayoutSidebarThingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutSidebarThingsRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/things/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarTrashIndexRoute =
  AuthlayoutSidebarTrashIndexRouteImport.update({
    id: '/trash/',
    path: '/trash/',
    getParentRoute: () => AuthlayoutSidebarLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/trash/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarTriggersIndexLazyRoute =
  AuthlayoutSidebarTriggersIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutSidebarTriggersRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/triggers/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSpaceoverviewDevicesIndexRoute =
  AuthlayoutSpaceoverviewDevicesIndexRouteImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => AuthlayoutSpaceoverviewRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/spaceoverview/devices/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSpaceoverviewPlanusageIndexRoute =
  AuthlayoutSpaceoverviewPlanusageIndexRouteImport.update({
    id: '/planusage/',
    path: '/planusage/',
    getParentRoute: () => AuthlayoutSpaceoverviewRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/spaceoverview/planusage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSpaceoverviewStatisticsIndexRoute =
  AuthlayoutSpaceoverviewStatisticsIndexRouteImport.update({
    id: '/statistics/',
    path: '/statistics/',
    getParentRoute: () => AuthlayoutSpaceoverviewRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/spaceoverview/statistics/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderDevicesIdIndexRoute =
  AuthlayoutHeaderDevicesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutHeaderDevicesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/devices/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderDevicesNewIndexRoute =
  AuthlayoutHeaderDevicesNewIndexRouteImport.update({
    id: '/devices/new/',
    path: '/devices/new/',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/devices/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTemplatesIdIndexRoute =
  AuthlayoutHeaderTemplatesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutHeaderTemplatesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/templates/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTemplatesNewIndexRoute =
  AuthlayoutHeaderTemplatesNewIndexRouteImport.update({
    id: '/templates/new/',
    path: '/templates/new/',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/templates/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderThingsIdIndexRoute =
  AuthlayoutHeaderThingsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutHeaderThingsIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/things/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderThingsNewIndexRoute =
  AuthlayoutHeaderThingsNewIndexRouteImport.update({
    id: '/things/new/',
    path: '/things/new/',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any)
const AuthlayoutHeaderTriggersIdIndexLazyRoute =
  AuthlayoutHeaderTriggersIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthlayoutHeaderTriggersIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/triggers/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTriggersNewIndexRoute =
  AuthlayoutHeaderTriggersNewIndexRouteImport.update({
    id: '/triggers/new/',
    path: '/triggers/new/',
    getParentRoute: () => AuthlayoutHeaderLazyRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/triggers/new/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderDevicesIdFwupdateIndexRoute =
  AuthlayoutHeaderDevicesIdFwupdateIndexRouteImport.update({
    id: '/fwupdate/',
    path: '/fwupdate/',
    getParentRoute: () => AuthlayoutHeaderDevicesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/devices/$id/fwupdate/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute =
  AuthlayoutHeaderDevicesIdNetworkconfigIndexRouteImport.update({
    id: '/networkconfig/',
    path: '/networkconfig/',
    getParentRoute: () => AuthlayoutHeaderDevicesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/devices/$id/networkconfig/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTemplatesIdApplyIndexRoute =
  AuthlayoutHeaderTemplatesIdApplyIndexRouteImport.update({
    id: '/apply/',
    path: '/apply/',
    getParentRoute: () => AuthlayoutHeaderTemplatesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/templates/$id/apply/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutHeaderTemplatesIdEditIndexRoute =
  AuthlayoutHeaderTemplatesIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => AuthlayoutHeaderTemplatesIdRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_header/templates/$id/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute =
  AuthlayoutSidebarDashboardsSmartfolderIdIndexRouteImport.update({
    id: '/smartfolder/$id/',
    path: '/smartfolder/$id/',
    getParentRoute: () => AuthlayoutSidebarDashboardsRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/dashboards/smartfolder/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarDevicesSmartfolderIdIndexRoute =
  AuthlayoutSidebarDevicesSmartfolderIdIndexRouteImport.update({
    id: '/smartfolder/$id/',
    path: '/smartfolder/$id/',
    getParentRoute: () => AuthlayoutSidebarDevicesRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/devices/smartfolder/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarThingsSmartfolderIdIndexRoute =
  AuthlayoutSidebarThingsSmartfolderIdIndexRouteImport.update({
    id: '/smartfolder/$id/',
    path: '/smartfolder/$id/',
    getParentRoute: () => AuthlayoutSidebarThingsRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/things/smartfolder/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthlayoutSidebarTriggersSmartfolderIdIndexRoute =
  AuthlayoutSidebarTriggersSmartfolderIdIndexRouteImport.update({
    id: '/smartfolder/$id/',
    path: '/smartfolder/$id/',
    getParentRoute: () => AuthlayoutSidebarTriggersRouteRoute,
  } as any).lazy(() =>
    import('./pages/_authlayout/_sidebar/triggers/smartfolder/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthlayoutSidebarIndexRoute
  '/chrome-app': typeof ChromeAppRoute
  '/spaceoverview': typeof AuthlayoutSpaceoverviewRouteRouteWithChildren
  '/minors': typeof NoAuthMinorsRoute
  '/dashboards': typeof AuthlayoutSidebarDashboardsRouteRouteWithChildren
  '/devices': typeof AuthlayoutSidebarDevicesRouteRouteWithChildren
  '/things': typeof AuthlayoutSidebarThingsRouteRouteWithChildren
  '/triggers': typeof AuthlayoutSidebarTriggersRouteRouteWithChildren
  '/auth-failed/': typeof NoAuthAuthFailedIndexRoute
  '/devices/$id': typeof AuthlayoutHeaderDevicesIdRouteRouteWithChildren
  '/templates/$id': typeof AuthlayoutHeaderTemplatesIdRouteRouteWithChildren
  '/things/$id': typeof AuthlayoutHeaderThingsIdRouteRouteWithChildren
  '/triggers/$id': typeof AuthlayoutHeaderTriggersIdRouteRouteWithChildren
  '/registration/': typeof AuthlayoutNoneRegistrationIndexRoute
  '/tos-acceptance/': typeof AuthlayoutNoneTosAcceptanceIndexRoute
  '/api-keys/': typeof AuthlayoutSidebarApiKeysIndexRoute
  '/branding/': typeof AuthlayoutSidebarBrandingIndexRoute
  '/courses/': typeof AuthlayoutSidebarCoursesIndexRoute
  '/integrations/': typeof AuthlayoutSidebarIntegrationsIndexRoute
  '/members/': typeof AuthlayoutSidebarMembersIndexRoute
  '/plan-usage/': typeof AuthlayoutSidebarPlanUsageIndexRoute
  '/resources/': typeof AuthlayoutSidebarResourcesIndexRoute
  '/roles-permissions/': typeof AuthlayoutSidebarRolesPermissionsIndexRoute
  '/settings/': typeof AuthlayoutSidebarSettingsIndexRoute
  '/sketches/': typeof AuthlayoutSidebarSketchesIndexRoute
  '/templates/': typeof AuthlayoutSidebarTemplatesIndexRoute
  '/trash/': typeof AuthlayoutSidebarTrashIndexRoute
  '/spaceoverview/devices/': typeof AuthlayoutSpaceoverviewDevicesIndexRoute
  '/spaceoverview/planusage/': typeof AuthlayoutSpaceoverviewPlanusageIndexRoute
  '/spaceoverview/statistics/': typeof AuthlayoutSpaceoverviewStatisticsIndexRoute
  '/dashboards/': typeof AuthlayoutSidebarDashboardsIndexLazyRoute
  '/devices/': typeof AuthlayoutSidebarDevicesIndexLazyRoute
  '/things/': typeof AuthlayoutSidebarThingsIndexLazyRoute
  '/triggers/': typeof AuthlayoutSidebarTriggersIndexLazyRoute
  '/devices/$id/': typeof AuthlayoutHeaderDevicesIdIndexRoute
  '/devices/new/': typeof AuthlayoutHeaderDevicesNewIndexRoute
  '/templates/$id/': typeof AuthlayoutHeaderTemplatesIdIndexRoute
  '/templates/new/': typeof AuthlayoutHeaderTemplatesNewIndexRoute
  '/things/$id/': typeof AuthlayoutHeaderThingsIdIndexRoute
  '/things/new/': typeof AuthlayoutHeaderThingsNewIndexRoute
  '/triggers/new/': typeof AuthlayoutHeaderTriggersNewIndexRoute
  '/triggers/$id/': typeof AuthlayoutHeaderTriggersIdIndexLazyRoute
  '/devices/$id/fwupdate/': typeof AuthlayoutHeaderDevicesIdFwupdateIndexRoute
  '/devices/$id/networkconfig/': typeof AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute
  '/templates/$id/apply/': typeof AuthlayoutHeaderTemplatesIdApplyIndexRoute
  '/templates/$id/edit/': typeof AuthlayoutHeaderTemplatesIdEditIndexRoute
  '/dashboards/smartfolder/$id/': typeof AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute
  '/devices/smartfolder/$id/': typeof AuthlayoutSidebarDevicesSmartfolderIdIndexRoute
  '/things/smartfolder/$id/': typeof AuthlayoutSidebarThingsSmartfolderIdIndexRoute
  '/triggers/smartfolder/$id/': typeof AuthlayoutSidebarTriggersSmartfolderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthlayoutSidebarIndexRoute
  '/chrome-app': typeof ChromeAppRoute
  '/spaceoverview': typeof AuthlayoutSpaceoverviewRouteRouteWithChildren
  '/minors': typeof NoAuthMinorsRoute
  '/auth-failed': typeof NoAuthAuthFailedIndexRoute
  '/registration': typeof AuthlayoutNoneRegistrationIndexRoute
  '/tos-acceptance': typeof AuthlayoutNoneTosAcceptanceIndexRoute
  '/api-keys': typeof AuthlayoutSidebarApiKeysIndexRoute
  '/branding': typeof AuthlayoutSidebarBrandingIndexRoute
  '/courses': typeof AuthlayoutSidebarCoursesIndexRoute
  '/integrations': typeof AuthlayoutSidebarIntegrationsIndexRoute
  '/members': typeof AuthlayoutSidebarMembersIndexRoute
  '/plan-usage': typeof AuthlayoutSidebarPlanUsageIndexRoute
  '/resources': typeof AuthlayoutSidebarResourcesIndexRoute
  '/roles-permissions': typeof AuthlayoutSidebarRolesPermissionsIndexRoute
  '/settings': typeof AuthlayoutSidebarSettingsIndexRoute
  '/sketches': typeof AuthlayoutSidebarSketchesIndexRoute
  '/templates': typeof AuthlayoutSidebarTemplatesIndexRoute
  '/trash': typeof AuthlayoutSidebarTrashIndexRoute
  '/spaceoverview/devices': typeof AuthlayoutSpaceoverviewDevicesIndexRoute
  '/spaceoverview/planusage': typeof AuthlayoutSpaceoverviewPlanusageIndexRoute
  '/spaceoverview/statistics': typeof AuthlayoutSpaceoverviewStatisticsIndexRoute
  '/dashboards': typeof AuthlayoutSidebarDashboardsIndexLazyRoute
  '/devices': typeof AuthlayoutSidebarDevicesIndexLazyRoute
  '/things': typeof AuthlayoutSidebarThingsIndexLazyRoute
  '/triggers': typeof AuthlayoutSidebarTriggersIndexLazyRoute
  '/devices/$id': typeof AuthlayoutHeaderDevicesIdIndexRoute
  '/devices/new': typeof AuthlayoutHeaderDevicesNewIndexRoute
  '/templates/$id': typeof AuthlayoutHeaderTemplatesIdIndexRoute
  '/templates/new': typeof AuthlayoutHeaderTemplatesNewIndexRoute
  '/things/$id': typeof AuthlayoutHeaderThingsIdIndexRoute
  '/things/new': typeof AuthlayoutHeaderThingsNewIndexRoute
  '/triggers/new': typeof AuthlayoutHeaderTriggersNewIndexRoute
  '/triggers/$id': typeof AuthlayoutHeaderTriggersIdIndexLazyRoute
  '/devices/$id/fwupdate': typeof AuthlayoutHeaderDevicesIdFwupdateIndexRoute
  '/devices/$id/networkconfig': typeof AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute
  '/templates/$id/apply': typeof AuthlayoutHeaderTemplatesIdApplyIndexRoute
  '/templates/$id/edit': typeof AuthlayoutHeaderTemplatesIdEditIndexRoute
  '/dashboards/smartfolder/$id': typeof AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute
  '/devices/smartfolder/$id': typeof AuthlayoutSidebarDevicesSmartfolderIdIndexRoute
  '/things/smartfolder/$id': typeof AuthlayoutSidebarThingsSmartfolderIdIndexRoute
  '/triggers/smartfolder/$id': typeof AuthlayoutSidebarTriggersSmartfolderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authlayout': typeof AuthlayoutRouteWithChildren
  '/_no-auth': typeof NoAuthRouteWithChildren
  '/chrome-app': typeof ChromeAppRoute
  '/_authlayout/spaceoverview': typeof AuthlayoutSpaceoverviewRouteRouteWithChildren
  '/_no-auth/minors': typeof NoAuthMinorsRoute
  '/_authlayout/_header': typeof AuthlayoutHeaderLazyRouteWithChildren
  '/_authlayout/_none': typeof AuthlayoutNoneLazyRouteWithChildren
  '/_authlayout/_sidebar': typeof AuthlayoutSidebarLazyRouteWithChildren
  '/_authlayout/_sidebar/dashboards': typeof AuthlayoutSidebarDashboardsRouteRouteWithChildren
  '/_authlayout/_sidebar/devices': typeof AuthlayoutSidebarDevicesRouteRouteWithChildren
  '/_authlayout/_sidebar/things': typeof AuthlayoutSidebarThingsRouteRouteWithChildren
  '/_authlayout/_sidebar/triggers': typeof AuthlayoutSidebarTriggersRouteRouteWithChildren
  '/_authlayout/_sidebar/': typeof AuthlayoutSidebarIndexRoute
  '/_no-auth/auth-failed/': typeof NoAuthAuthFailedIndexRoute
  '/_authlayout/_header/devices/$id': typeof AuthlayoutHeaderDevicesIdRouteRouteWithChildren
  '/_authlayout/_header/templates/$id': typeof AuthlayoutHeaderTemplatesIdRouteRouteWithChildren
  '/_authlayout/_header/things/$id': typeof AuthlayoutHeaderThingsIdRouteRouteWithChildren
  '/_authlayout/_header/triggers/$id': typeof AuthlayoutHeaderTriggersIdRouteRouteWithChildren
  '/_authlayout/_none/registration/': typeof AuthlayoutNoneRegistrationIndexRoute
  '/_authlayout/_none/tos-acceptance/': typeof AuthlayoutNoneTosAcceptanceIndexRoute
  '/_authlayout/_sidebar/api-keys/': typeof AuthlayoutSidebarApiKeysIndexRoute
  '/_authlayout/_sidebar/branding/': typeof AuthlayoutSidebarBrandingIndexRoute
  '/_authlayout/_sidebar/courses/': typeof AuthlayoutSidebarCoursesIndexRoute
  '/_authlayout/_sidebar/integrations/': typeof AuthlayoutSidebarIntegrationsIndexRoute
  '/_authlayout/_sidebar/members/': typeof AuthlayoutSidebarMembersIndexRoute
  '/_authlayout/_sidebar/plan-usage/': typeof AuthlayoutSidebarPlanUsageIndexRoute
  '/_authlayout/_sidebar/resources/': typeof AuthlayoutSidebarResourcesIndexRoute
  '/_authlayout/_sidebar/roles-permissions/': typeof AuthlayoutSidebarRolesPermissionsIndexRoute
  '/_authlayout/_sidebar/settings/': typeof AuthlayoutSidebarSettingsIndexRoute
  '/_authlayout/_sidebar/sketches/': typeof AuthlayoutSidebarSketchesIndexRoute
  '/_authlayout/_sidebar/templates/': typeof AuthlayoutSidebarTemplatesIndexRoute
  '/_authlayout/_sidebar/trash/': typeof AuthlayoutSidebarTrashIndexRoute
  '/_authlayout/spaceoverview/devices/': typeof AuthlayoutSpaceoverviewDevicesIndexRoute
  '/_authlayout/spaceoverview/planusage/': typeof AuthlayoutSpaceoverviewPlanusageIndexRoute
  '/_authlayout/spaceoverview/statistics/': typeof AuthlayoutSpaceoverviewStatisticsIndexRoute
  '/_authlayout/_sidebar/dashboards/': typeof AuthlayoutSidebarDashboardsIndexLazyRoute
  '/_authlayout/_sidebar/devices/': typeof AuthlayoutSidebarDevicesIndexLazyRoute
  '/_authlayout/_sidebar/things/': typeof AuthlayoutSidebarThingsIndexLazyRoute
  '/_authlayout/_sidebar/triggers/': typeof AuthlayoutSidebarTriggersIndexLazyRoute
  '/_authlayout/_header/devices/$id/': typeof AuthlayoutHeaderDevicesIdIndexRoute
  '/_authlayout/_header/devices/new/': typeof AuthlayoutHeaderDevicesNewIndexRoute
  '/_authlayout/_header/templates/$id/': typeof AuthlayoutHeaderTemplatesIdIndexRoute
  '/_authlayout/_header/templates/new/': typeof AuthlayoutHeaderTemplatesNewIndexRoute
  '/_authlayout/_header/things/$id/': typeof AuthlayoutHeaderThingsIdIndexRoute
  '/_authlayout/_header/things/new/': typeof AuthlayoutHeaderThingsNewIndexRoute
  '/_authlayout/_header/triggers/new/': typeof AuthlayoutHeaderTriggersNewIndexRoute
  '/_authlayout/_header/triggers/$id/': typeof AuthlayoutHeaderTriggersIdIndexLazyRoute
  '/_authlayout/_header/devices/$id/fwupdate/': typeof AuthlayoutHeaderDevicesIdFwupdateIndexRoute
  '/_authlayout/_header/devices/$id/networkconfig/': typeof AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute
  '/_authlayout/_header/templates/$id/apply/': typeof AuthlayoutHeaderTemplatesIdApplyIndexRoute
  '/_authlayout/_header/templates/$id/edit/': typeof AuthlayoutHeaderTemplatesIdEditIndexRoute
  '/_authlayout/_sidebar/dashboards/smartfolder/$id/': typeof AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute
  '/_authlayout/_sidebar/devices/smartfolder/$id/': typeof AuthlayoutSidebarDevicesSmartfolderIdIndexRoute
  '/_authlayout/_sidebar/things/smartfolder/$id/': typeof AuthlayoutSidebarThingsSmartfolderIdIndexRoute
  '/_authlayout/_sidebar/triggers/smartfolder/$id/': typeof AuthlayoutSidebarTriggersSmartfolderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chrome-app'
    | '/spaceoverview'
    | '/minors'
    | '/dashboards'
    | '/devices'
    | '/things'
    | '/triggers'
    | '/auth-failed/'
    | '/devices/$id'
    | '/templates/$id'
    | '/things/$id'
    | '/triggers/$id'
    | '/registration/'
    | '/tos-acceptance/'
    | '/api-keys/'
    | '/branding/'
    | '/courses/'
    | '/integrations/'
    | '/members/'
    | '/plan-usage/'
    | '/resources/'
    | '/roles-permissions/'
    | '/settings/'
    | '/sketches/'
    | '/templates/'
    | '/trash/'
    | '/spaceoverview/devices/'
    | '/spaceoverview/planusage/'
    | '/spaceoverview/statistics/'
    | '/dashboards/'
    | '/devices/'
    | '/things/'
    | '/triggers/'
    | '/devices/$id/'
    | '/devices/new/'
    | '/templates/$id/'
    | '/templates/new/'
    | '/things/$id/'
    | '/things/new/'
    | '/triggers/new/'
    | '/triggers/$id/'
    | '/devices/$id/fwupdate/'
    | '/devices/$id/networkconfig/'
    | '/templates/$id/apply/'
    | '/templates/$id/edit/'
    | '/dashboards/smartfolder/$id/'
    | '/devices/smartfolder/$id/'
    | '/things/smartfolder/$id/'
    | '/triggers/smartfolder/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chrome-app'
    | '/spaceoverview'
    | '/minors'
    | '/auth-failed'
    | '/registration'
    | '/tos-acceptance'
    | '/api-keys'
    | '/branding'
    | '/courses'
    | '/integrations'
    | '/members'
    | '/plan-usage'
    | '/resources'
    | '/roles-permissions'
    | '/settings'
    | '/sketches'
    | '/templates'
    | '/trash'
    | '/spaceoverview/devices'
    | '/spaceoverview/planusage'
    | '/spaceoverview/statistics'
    | '/dashboards'
    | '/devices'
    | '/things'
    | '/triggers'
    | '/devices/$id'
    | '/devices/new'
    | '/templates/$id'
    | '/templates/new'
    | '/things/$id'
    | '/things/new'
    | '/triggers/new'
    | '/triggers/$id'
    | '/devices/$id/fwupdate'
    | '/devices/$id/networkconfig'
    | '/templates/$id/apply'
    | '/templates/$id/edit'
    | '/dashboards/smartfolder/$id'
    | '/devices/smartfolder/$id'
    | '/things/smartfolder/$id'
    | '/triggers/smartfolder/$id'
  id:
    | '__root__'
    | '/_authlayout'
    | '/_no-auth'
    | '/chrome-app'
    | '/_authlayout/spaceoverview'
    | '/_no-auth/minors'
    | '/_authlayout/_header'
    | '/_authlayout/_none'
    | '/_authlayout/_sidebar'
    | '/_authlayout/_sidebar/dashboards'
    | '/_authlayout/_sidebar/devices'
    | '/_authlayout/_sidebar/things'
    | '/_authlayout/_sidebar/triggers'
    | '/_authlayout/_sidebar/'
    | '/_no-auth/auth-failed/'
    | '/_authlayout/_header/devices/$id'
    | '/_authlayout/_header/templates/$id'
    | '/_authlayout/_header/things/$id'
    | '/_authlayout/_header/triggers/$id'
    | '/_authlayout/_none/registration/'
    | '/_authlayout/_none/tos-acceptance/'
    | '/_authlayout/_sidebar/api-keys/'
    | '/_authlayout/_sidebar/branding/'
    | '/_authlayout/_sidebar/courses/'
    | '/_authlayout/_sidebar/integrations/'
    | '/_authlayout/_sidebar/members/'
    | '/_authlayout/_sidebar/plan-usage/'
    | '/_authlayout/_sidebar/resources/'
    | '/_authlayout/_sidebar/roles-permissions/'
    | '/_authlayout/_sidebar/settings/'
    | '/_authlayout/_sidebar/sketches/'
    | '/_authlayout/_sidebar/templates/'
    | '/_authlayout/_sidebar/trash/'
    | '/_authlayout/spaceoverview/devices/'
    | '/_authlayout/spaceoverview/planusage/'
    | '/_authlayout/spaceoverview/statistics/'
    | '/_authlayout/_sidebar/dashboards/'
    | '/_authlayout/_sidebar/devices/'
    | '/_authlayout/_sidebar/things/'
    | '/_authlayout/_sidebar/triggers/'
    | '/_authlayout/_header/devices/$id/'
    | '/_authlayout/_header/devices/new/'
    | '/_authlayout/_header/templates/$id/'
    | '/_authlayout/_header/templates/new/'
    | '/_authlayout/_header/things/$id/'
    | '/_authlayout/_header/things/new/'
    | '/_authlayout/_header/triggers/new/'
    | '/_authlayout/_header/triggers/$id/'
    | '/_authlayout/_header/devices/$id/fwupdate/'
    | '/_authlayout/_header/devices/$id/networkconfig/'
    | '/_authlayout/_header/templates/$id/apply/'
    | '/_authlayout/_header/templates/$id/edit/'
    | '/_authlayout/_sidebar/dashboards/smartfolder/$id/'
    | '/_authlayout/_sidebar/devices/smartfolder/$id/'
    | '/_authlayout/_sidebar/things/smartfolder/$id/'
    | '/_authlayout/_sidebar/triggers/smartfolder/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthlayoutRoute: typeof AuthlayoutRouteWithChildren
  NoAuthRoute: typeof NoAuthRouteWithChildren
  ChromeAppRoute: typeof ChromeAppRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authlayout': {
      id: '/_authlayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthlayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_no-auth': {
      id: '/_no-auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof NoAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chrome-app': {
      id: '/chrome-app'
      path: '/chrome-app'
      fullPath: '/chrome-app'
      preLoaderRoute: typeof ChromeAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authlayout/_header': {
      id: '/_authlayout/_header'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthlayoutHeaderLazyRouteImport
      parentRoute: typeof AuthlayoutRoute
    }
    '/_authlayout/_none': {
      id: '/_authlayout/_none'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthlayoutNoneLazyRouteImport
      parentRoute: typeof AuthlayoutRoute
    }
    '/_authlayout/_sidebar': {
      id: '/_authlayout/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthlayoutSidebarLazyRouteImport
      parentRoute: typeof AuthlayoutRoute
    }
    '/_authlayout/spaceoverview': {
      id: '/_authlayout/spaceoverview'
      path: '/spaceoverview'
      fullPath: '/spaceoverview'
      preLoaderRoute: typeof AuthlayoutSpaceoverviewRouteRouteImport
      parentRoute: typeof AuthlayoutRoute
    }
    '/_no-auth/minors': {
      id: '/_no-auth/minors'
      path: '/minors'
      fullPath: '/minors'
      preLoaderRoute: typeof NoAuthMinorsRouteImport
      parentRoute: typeof NoAuthRoute
    }
    '/_authlayout/_sidebar/': {
      id: '/_authlayout/_sidebar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthlayoutSidebarIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/dashboards': {
      id: '/_authlayout/_sidebar/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AuthlayoutSidebarDashboardsRouteRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/devices': {
      id: '/_authlayout/_sidebar/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthlayoutSidebarDevicesRouteRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/things': {
      id: '/_authlayout/_sidebar/things'
      path: '/things'
      fullPath: '/things'
      preLoaderRoute: typeof AuthlayoutSidebarThingsRouteRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/triggers': {
      id: '/_authlayout/_sidebar/triggers'
      path: '/triggers'
      fullPath: '/triggers'
      preLoaderRoute: typeof AuthlayoutSidebarTriggersRouteRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_no-auth/auth-failed/': {
      id: '/_no-auth/auth-failed/'
      path: '/auth-failed'
      fullPath: '/auth-failed/'
      preLoaderRoute: typeof NoAuthAuthFailedIndexRouteImport
      parentRoute: typeof NoAuthRoute
    }
    '/_authlayout/_header/devices/$id': {
      id: '/_authlayout/_header/devices/$id'
      path: '/devices/$id'
      fullPath: '/devices/$id'
      preLoaderRoute: typeof AuthlayoutHeaderDevicesIdRouteRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/templates/$id': {
      id: '/_authlayout/_header/templates/$id'
      path: '/templates/$id'
      fullPath: '/templates/$id'
      preLoaderRoute: typeof AuthlayoutHeaderTemplatesIdRouteRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/things/$id': {
      id: '/_authlayout/_header/things/$id'
      path: '/things/$id'
      fullPath: '/things/$id'
      preLoaderRoute: typeof AuthlayoutHeaderThingsIdRouteRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/triggers/$id': {
      id: '/_authlayout/_header/triggers/$id'
      path: '/triggers/$id'
      fullPath: '/triggers/$id'
      preLoaderRoute: typeof AuthlayoutHeaderTriggersIdRouteRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_none/registration/': {
      id: '/_authlayout/_none/registration/'
      path: '/registration'
      fullPath: '/registration/'
      preLoaderRoute: typeof AuthlayoutNoneRegistrationIndexRouteImport
      parentRoute: typeof AuthlayoutNoneLazyRoute
    }
    '/_authlayout/_none/tos-acceptance/': {
      id: '/_authlayout/_none/tos-acceptance/'
      path: '/tos-acceptance'
      fullPath: '/tos-acceptance/'
      preLoaderRoute: typeof AuthlayoutNoneTosAcceptanceIndexRouteImport
      parentRoute: typeof AuthlayoutNoneLazyRoute
    }
    '/_authlayout/_sidebar/api-keys/': {
      id: '/_authlayout/_sidebar/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof AuthlayoutSidebarApiKeysIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/branding/': {
      id: '/_authlayout/_sidebar/branding/'
      path: '/branding'
      fullPath: '/branding/'
      preLoaderRoute: typeof AuthlayoutSidebarBrandingIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/courses/': {
      id: '/_authlayout/_sidebar/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof AuthlayoutSidebarCoursesIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/dashboards/': {
      id: '/_authlayout/_sidebar/dashboards/'
      path: '/'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AuthlayoutSidebarDashboardsIndexLazyRouteImport
      parentRoute: typeof AuthlayoutSidebarDashboardsRouteRoute
    }
    '/_authlayout/_sidebar/devices/': {
      id: '/_authlayout/_sidebar/devices/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof AuthlayoutSidebarDevicesIndexLazyRouteImport
      parentRoute: typeof AuthlayoutSidebarDevicesRouteRoute
    }
    '/_authlayout/_sidebar/integrations/': {
      id: '/_authlayout/_sidebar/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthlayoutSidebarIntegrationsIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/members/': {
      id: '/_authlayout/_sidebar/members/'
      path: '/members'
      fullPath: '/members/'
      preLoaderRoute: typeof AuthlayoutSidebarMembersIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/plan-usage/': {
      id: '/_authlayout/_sidebar/plan-usage/'
      path: '/plan-usage'
      fullPath: '/plan-usage/'
      preLoaderRoute: typeof AuthlayoutSidebarPlanUsageIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/resources/': {
      id: '/_authlayout/_sidebar/resources/'
      path: '/resources'
      fullPath: '/resources/'
      preLoaderRoute: typeof AuthlayoutSidebarResourcesIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/roles-permissions/': {
      id: '/_authlayout/_sidebar/roles-permissions/'
      path: '/roles-permissions'
      fullPath: '/roles-permissions/'
      preLoaderRoute: typeof AuthlayoutSidebarRolesPermissionsIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/settings/': {
      id: '/_authlayout/_sidebar/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthlayoutSidebarSettingsIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/sketches/': {
      id: '/_authlayout/_sidebar/sketches/'
      path: '/sketches'
      fullPath: '/sketches/'
      preLoaderRoute: typeof AuthlayoutSidebarSketchesIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/templates/': {
      id: '/_authlayout/_sidebar/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthlayoutSidebarTemplatesIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/things/': {
      id: '/_authlayout/_sidebar/things/'
      path: '/'
      fullPath: '/things/'
      preLoaderRoute: typeof AuthlayoutSidebarThingsIndexLazyRouteImport
      parentRoute: typeof AuthlayoutSidebarThingsRouteRoute
    }
    '/_authlayout/_sidebar/trash/': {
      id: '/_authlayout/_sidebar/trash/'
      path: '/trash'
      fullPath: '/trash/'
      preLoaderRoute: typeof AuthlayoutSidebarTrashIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarLazyRoute
    }
    '/_authlayout/_sidebar/triggers/': {
      id: '/_authlayout/_sidebar/triggers/'
      path: '/'
      fullPath: '/triggers/'
      preLoaderRoute: typeof AuthlayoutSidebarTriggersIndexLazyRouteImport
      parentRoute: typeof AuthlayoutSidebarTriggersRouteRoute
    }
    '/_authlayout/spaceoverview/devices/': {
      id: '/_authlayout/spaceoverview/devices/'
      path: '/devices'
      fullPath: '/spaceoverview/devices/'
      preLoaderRoute: typeof AuthlayoutSpaceoverviewDevicesIndexRouteImport
      parentRoute: typeof AuthlayoutSpaceoverviewRouteRoute
    }
    '/_authlayout/spaceoverview/planusage/': {
      id: '/_authlayout/spaceoverview/planusage/'
      path: '/planusage'
      fullPath: '/spaceoverview/planusage/'
      preLoaderRoute: typeof AuthlayoutSpaceoverviewPlanusageIndexRouteImport
      parentRoute: typeof AuthlayoutSpaceoverviewRouteRoute
    }
    '/_authlayout/spaceoverview/statistics/': {
      id: '/_authlayout/spaceoverview/statistics/'
      path: '/statistics'
      fullPath: '/spaceoverview/statistics/'
      preLoaderRoute: typeof AuthlayoutSpaceoverviewStatisticsIndexRouteImport
      parentRoute: typeof AuthlayoutSpaceoverviewRouteRoute
    }
    '/_authlayout/_header/devices/$id/': {
      id: '/_authlayout/_header/devices/$id/'
      path: '/'
      fullPath: '/devices/$id/'
      preLoaderRoute: typeof AuthlayoutHeaderDevicesIdIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderDevicesIdRouteRoute
    }
    '/_authlayout/_header/devices/new/': {
      id: '/_authlayout/_header/devices/new/'
      path: '/devices/new'
      fullPath: '/devices/new/'
      preLoaderRoute: typeof AuthlayoutHeaderDevicesNewIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/templates/$id/': {
      id: '/_authlayout/_header/templates/$id/'
      path: '/'
      fullPath: '/templates/$id/'
      preLoaderRoute: typeof AuthlayoutHeaderTemplatesIdIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderTemplatesIdRouteRoute
    }
    '/_authlayout/_header/templates/new/': {
      id: '/_authlayout/_header/templates/new/'
      path: '/templates/new'
      fullPath: '/templates/new/'
      preLoaderRoute: typeof AuthlayoutHeaderTemplatesNewIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/things/$id/': {
      id: '/_authlayout/_header/things/$id/'
      path: '/'
      fullPath: '/things/$id/'
      preLoaderRoute: typeof AuthlayoutHeaderThingsIdIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderThingsIdRouteRoute
    }
    '/_authlayout/_header/things/new/': {
      id: '/_authlayout/_header/things/new/'
      path: '/things/new'
      fullPath: '/things/new/'
      preLoaderRoute: typeof AuthlayoutHeaderThingsNewIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/triggers/$id/': {
      id: '/_authlayout/_header/triggers/$id/'
      path: '/'
      fullPath: '/triggers/$id/'
      preLoaderRoute: typeof AuthlayoutHeaderTriggersIdIndexLazyRouteImport
      parentRoute: typeof AuthlayoutHeaderTriggersIdRouteRoute
    }
    '/_authlayout/_header/triggers/new/': {
      id: '/_authlayout/_header/triggers/new/'
      path: '/triggers/new'
      fullPath: '/triggers/new/'
      preLoaderRoute: typeof AuthlayoutHeaderTriggersNewIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderLazyRoute
    }
    '/_authlayout/_header/devices/$id/fwupdate/': {
      id: '/_authlayout/_header/devices/$id/fwupdate/'
      path: '/fwupdate'
      fullPath: '/devices/$id/fwupdate/'
      preLoaderRoute: typeof AuthlayoutHeaderDevicesIdFwupdateIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderDevicesIdRouteRoute
    }
    '/_authlayout/_header/devices/$id/networkconfig/': {
      id: '/_authlayout/_header/devices/$id/networkconfig/'
      path: '/networkconfig'
      fullPath: '/devices/$id/networkconfig/'
      preLoaderRoute: typeof AuthlayoutHeaderDevicesIdNetworkconfigIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderDevicesIdRouteRoute
    }
    '/_authlayout/_header/templates/$id/apply/': {
      id: '/_authlayout/_header/templates/$id/apply/'
      path: '/apply'
      fullPath: '/templates/$id/apply/'
      preLoaderRoute: typeof AuthlayoutHeaderTemplatesIdApplyIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderTemplatesIdRouteRoute
    }
    '/_authlayout/_header/templates/$id/edit/': {
      id: '/_authlayout/_header/templates/$id/edit/'
      path: '/edit'
      fullPath: '/templates/$id/edit/'
      preLoaderRoute: typeof AuthlayoutHeaderTemplatesIdEditIndexRouteImport
      parentRoute: typeof AuthlayoutHeaderTemplatesIdRouteRoute
    }
    '/_authlayout/_sidebar/dashboards/smartfolder/$id/': {
      id: '/_authlayout/_sidebar/dashboards/smartfolder/$id/'
      path: '/smartfolder/$id'
      fullPath: '/dashboards/smartfolder/$id/'
      preLoaderRoute: typeof AuthlayoutSidebarDashboardsSmartfolderIdIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarDashboardsRouteRoute
    }
    '/_authlayout/_sidebar/devices/smartfolder/$id/': {
      id: '/_authlayout/_sidebar/devices/smartfolder/$id/'
      path: '/smartfolder/$id'
      fullPath: '/devices/smartfolder/$id/'
      preLoaderRoute: typeof AuthlayoutSidebarDevicesSmartfolderIdIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarDevicesRouteRoute
    }
    '/_authlayout/_sidebar/things/smartfolder/$id/': {
      id: '/_authlayout/_sidebar/things/smartfolder/$id/'
      path: '/smartfolder/$id'
      fullPath: '/things/smartfolder/$id/'
      preLoaderRoute: typeof AuthlayoutSidebarThingsSmartfolderIdIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarThingsRouteRoute
    }
    '/_authlayout/_sidebar/triggers/smartfolder/$id/': {
      id: '/_authlayout/_sidebar/triggers/smartfolder/$id/'
      path: '/smartfolder/$id'
      fullPath: '/triggers/smartfolder/$id/'
      preLoaderRoute: typeof AuthlayoutSidebarTriggersSmartfolderIdIndexRouteImport
      parentRoute: typeof AuthlayoutSidebarTriggersRouteRoute
    }
  }
}

interface AuthlayoutSpaceoverviewRouteRouteChildren {
  AuthlayoutSpaceoverviewDevicesIndexRoute: typeof AuthlayoutSpaceoverviewDevicesIndexRoute
  AuthlayoutSpaceoverviewPlanusageIndexRoute: typeof AuthlayoutSpaceoverviewPlanusageIndexRoute
  AuthlayoutSpaceoverviewStatisticsIndexRoute: typeof AuthlayoutSpaceoverviewStatisticsIndexRoute
}

const AuthlayoutSpaceoverviewRouteRouteChildren: AuthlayoutSpaceoverviewRouteRouteChildren =
  {
    AuthlayoutSpaceoverviewDevicesIndexRoute:
      AuthlayoutSpaceoverviewDevicesIndexRoute,
    AuthlayoutSpaceoverviewPlanusageIndexRoute:
      AuthlayoutSpaceoverviewPlanusageIndexRoute,
    AuthlayoutSpaceoverviewStatisticsIndexRoute:
      AuthlayoutSpaceoverviewStatisticsIndexRoute,
  }

const AuthlayoutSpaceoverviewRouteRouteWithChildren =
  AuthlayoutSpaceoverviewRouteRoute._addFileChildren(
    AuthlayoutSpaceoverviewRouteRouteChildren,
  )

interface AuthlayoutHeaderDevicesIdRouteRouteChildren {
  AuthlayoutHeaderDevicesIdIndexRoute: typeof AuthlayoutHeaderDevicesIdIndexRoute
  AuthlayoutHeaderDevicesIdFwupdateIndexRoute: typeof AuthlayoutHeaderDevicesIdFwupdateIndexRoute
  AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute: typeof AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute
}

const AuthlayoutHeaderDevicesIdRouteRouteChildren: AuthlayoutHeaderDevicesIdRouteRouteChildren =
  {
    AuthlayoutHeaderDevicesIdIndexRoute: AuthlayoutHeaderDevicesIdIndexRoute,
    AuthlayoutHeaderDevicesIdFwupdateIndexRoute:
      AuthlayoutHeaderDevicesIdFwupdateIndexRoute,
    AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute:
      AuthlayoutHeaderDevicesIdNetworkconfigIndexRoute,
  }

const AuthlayoutHeaderDevicesIdRouteRouteWithChildren =
  AuthlayoutHeaderDevicesIdRouteRoute._addFileChildren(
    AuthlayoutHeaderDevicesIdRouteRouteChildren,
  )

interface AuthlayoutHeaderTemplatesIdRouteRouteChildren {
  AuthlayoutHeaderTemplatesIdIndexRoute: typeof AuthlayoutHeaderTemplatesIdIndexRoute
  AuthlayoutHeaderTemplatesIdApplyIndexRoute: typeof AuthlayoutHeaderTemplatesIdApplyIndexRoute
  AuthlayoutHeaderTemplatesIdEditIndexRoute: typeof AuthlayoutHeaderTemplatesIdEditIndexRoute
}

const AuthlayoutHeaderTemplatesIdRouteRouteChildren: AuthlayoutHeaderTemplatesIdRouteRouteChildren =
  {
    AuthlayoutHeaderTemplatesIdIndexRoute:
      AuthlayoutHeaderTemplatesIdIndexRoute,
    AuthlayoutHeaderTemplatesIdApplyIndexRoute:
      AuthlayoutHeaderTemplatesIdApplyIndexRoute,
    AuthlayoutHeaderTemplatesIdEditIndexRoute:
      AuthlayoutHeaderTemplatesIdEditIndexRoute,
  }

const AuthlayoutHeaderTemplatesIdRouteRouteWithChildren =
  AuthlayoutHeaderTemplatesIdRouteRoute._addFileChildren(
    AuthlayoutHeaderTemplatesIdRouteRouteChildren,
  )

interface AuthlayoutHeaderThingsIdRouteRouteChildren {
  AuthlayoutHeaderThingsIdIndexRoute: typeof AuthlayoutHeaderThingsIdIndexRoute
}

const AuthlayoutHeaderThingsIdRouteRouteChildren: AuthlayoutHeaderThingsIdRouteRouteChildren =
  {
    AuthlayoutHeaderThingsIdIndexRoute: AuthlayoutHeaderThingsIdIndexRoute,
  }

const AuthlayoutHeaderThingsIdRouteRouteWithChildren =
  AuthlayoutHeaderThingsIdRouteRoute._addFileChildren(
    AuthlayoutHeaderThingsIdRouteRouteChildren,
  )

interface AuthlayoutHeaderTriggersIdRouteRouteChildren {
  AuthlayoutHeaderTriggersIdIndexLazyRoute: typeof AuthlayoutHeaderTriggersIdIndexLazyRoute
}

const AuthlayoutHeaderTriggersIdRouteRouteChildren: AuthlayoutHeaderTriggersIdRouteRouteChildren =
  {
    AuthlayoutHeaderTriggersIdIndexLazyRoute:
      AuthlayoutHeaderTriggersIdIndexLazyRoute,
  }

const AuthlayoutHeaderTriggersIdRouteRouteWithChildren =
  AuthlayoutHeaderTriggersIdRouteRoute._addFileChildren(
    AuthlayoutHeaderTriggersIdRouteRouteChildren,
  )

interface AuthlayoutHeaderLazyRouteChildren {
  AuthlayoutHeaderDevicesIdRouteRoute: typeof AuthlayoutHeaderDevicesIdRouteRouteWithChildren
  AuthlayoutHeaderTemplatesIdRouteRoute: typeof AuthlayoutHeaderTemplatesIdRouteRouteWithChildren
  AuthlayoutHeaderThingsIdRouteRoute: typeof AuthlayoutHeaderThingsIdRouteRouteWithChildren
  AuthlayoutHeaderTriggersIdRouteRoute: typeof AuthlayoutHeaderTriggersIdRouteRouteWithChildren
  AuthlayoutHeaderDevicesNewIndexRoute: typeof AuthlayoutHeaderDevicesNewIndexRoute
  AuthlayoutHeaderTemplatesNewIndexRoute: typeof AuthlayoutHeaderTemplatesNewIndexRoute
  AuthlayoutHeaderThingsNewIndexRoute: typeof AuthlayoutHeaderThingsNewIndexRoute
  AuthlayoutHeaderTriggersNewIndexRoute: typeof AuthlayoutHeaderTriggersNewIndexRoute
}

const AuthlayoutHeaderLazyRouteChildren: AuthlayoutHeaderLazyRouteChildren = {
  AuthlayoutHeaderDevicesIdRouteRoute:
    AuthlayoutHeaderDevicesIdRouteRouteWithChildren,
  AuthlayoutHeaderTemplatesIdRouteRoute:
    AuthlayoutHeaderTemplatesIdRouteRouteWithChildren,
  AuthlayoutHeaderThingsIdRouteRoute:
    AuthlayoutHeaderThingsIdRouteRouteWithChildren,
  AuthlayoutHeaderTriggersIdRouteRoute:
    AuthlayoutHeaderTriggersIdRouteRouteWithChildren,
  AuthlayoutHeaderDevicesNewIndexRoute: AuthlayoutHeaderDevicesNewIndexRoute,
  AuthlayoutHeaderTemplatesNewIndexRoute:
    AuthlayoutHeaderTemplatesNewIndexRoute,
  AuthlayoutHeaderThingsNewIndexRoute: AuthlayoutHeaderThingsNewIndexRoute,
  AuthlayoutHeaderTriggersNewIndexRoute: AuthlayoutHeaderTriggersNewIndexRoute,
}

const AuthlayoutHeaderLazyRouteWithChildren =
  AuthlayoutHeaderLazyRoute._addFileChildren(AuthlayoutHeaderLazyRouteChildren)

interface AuthlayoutNoneLazyRouteChildren {
  AuthlayoutNoneRegistrationIndexRoute: typeof AuthlayoutNoneRegistrationIndexRoute
  AuthlayoutNoneTosAcceptanceIndexRoute: typeof AuthlayoutNoneTosAcceptanceIndexRoute
}

const AuthlayoutNoneLazyRouteChildren: AuthlayoutNoneLazyRouteChildren = {
  AuthlayoutNoneRegistrationIndexRoute: AuthlayoutNoneRegistrationIndexRoute,
  AuthlayoutNoneTosAcceptanceIndexRoute: AuthlayoutNoneTosAcceptanceIndexRoute,
}

const AuthlayoutNoneLazyRouteWithChildren =
  AuthlayoutNoneLazyRoute._addFileChildren(AuthlayoutNoneLazyRouteChildren)

interface AuthlayoutSidebarDashboardsRouteRouteChildren {
  AuthlayoutSidebarDashboardsIndexLazyRoute: typeof AuthlayoutSidebarDashboardsIndexLazyRoute
  AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute: typeof AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute
}

const AuthlayoutSidebarDashboardsRouteRouteChildren: AuthlayoutSidebarDashboardsRouteRouteChildren =
  {
    AuthlayoutSidebarDashboardsIndexLazyRoute:
      AuthlayoutSidebarDashboardsIndexLazyRoute,
    AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute:
      AuthlayoutSidebarDashboardsSmartfolderIdIndexRoute,
  }

const AuthlayoutSidebarDashboardsRouteRouteWithChildren =
  AuthlayoutSidebarDashboardsRouteRoute._addFileChildren(
    AuthlayoutSidebarDashboardsRouteRouteChildren,
  )

interface AuthlayoutSidebarDevicesRouteRouteChildren {
  AuthlayoutSidebarDevicesIndexLazyRoute: typeof AuthlayoutSidebarDevicesIndexLazyRoute
  AuthlayoutSidebarDevicesSmartfolderIdIndexRoute: typeof AuthlayoutSidebarDevicesSmartfolderIdIndexRoute
}

const AuthlayoutSidebarDevicesRouteRouteChildren: AuthlayoutSidebarDevicesRouteRouteChildren =
  {
    AuthlayoutSidebarDevicesIndexLazyRoute:
      AuthlayoutSidebarDevicesIndexLazyRoute,
    AuthlayoutSidebarDevicesSmartfolderIdIndexRoute:
      AuthlayoutSidebarDevicesSmartfolderIdIndexRoute,
  }

const AuthlayoutSidebarDevicesRouteRouteWithChildren =
  AuthlayoutSidebarDevicesRouteRoute._addFileChildren(
    AuthlayoutSidebarDevicesRouteRouteChildren,
  )

interface AuthlayoutSidebarThingsRouteRouteChildren {
  AuthlayoutSidebarThingsIndexLazyRoute: typeof AuthlayoutSidebarThingsIndexLazyRoute
  AuthlayoutSidebarThingsSmartfolderIdIndexRoute: typeof AuthlayoutSidebarThingsSmartfolderIdIndexRoute
}

const AuthlayoutSidebarThingsRouteRouteChildren: AuthlayoutSidebarThingsRouteRouteChildren =
  {
    AuthlayoutSidebarThingsIndexLazyRoute:
      AuthlayoutSidebarThingsIndexLazyRoute,
    AuthlayoutSidebarThingsSmartfolderIdIndexRoute:
      AuthlayoutSidebarThingsSmartfolderIdIndexRoute,
  }

const AuthlayoutSidebarThingsRouteRouteWithChildren =
  AuthlayoutSidebarThingsRouteRoute._addFileChildren(
    AuthlayoutSidebarThingsRouteRouteChildren,
  )

interface AuthlayoutSidebarTriggersRouteRouteChildren {
  AuthlayoutSidebarTriggersIndexLazyRoute: typeof AuthlayoutSidebarTriggersIndexLazyRoute
  AuthlayoutSidebarTriggersSmartfolderIdIndexRoute: typeof AuthlayoutSidebarTriggersSmartfolderIdIndexRoute
}

const AuthlayoutSidebarTriggersRouteRouteChildren: AuthlayoutSidebarTriggersRouteRouteChildren =
  {
    AuthlayoutSidebarTriggersIndexLazyRoute:
      AuthlayoutSidebarTriggersIndexLazyRoute,
    AuthlayoutSidebarTriggersSmartfolderIdIndexRoute:
      AuthlayoutSidebarTriggersSmartfolderIdIndexRoute,
  }

const AuthlayoutSidebarTriggersRouteRouteWithChildren =
  AuthlayoutSidebarTriggersRouteRoute._addFileChildren(
    AuthlayoutSidebarTriggersRouteRouteChildren,
  )

interface AuthlayoutSidebarLazyRouteChildren {
  AuthlayoutSidebarDashboardsRouteRoute: typeof AuthlayoutSidebarDashboardsRouteRouteWithChildren
  AuthlayoutSidebarDevicesRouteRoute: typeof AuthlayoutSidebarDevicesRouteRouteWithChildren
  AuthlayoutSidebarThingsRouteRoute: typeof AuthlayoutSidebarThingsRouteRouteWithChildren
  AuthlayoutSidebarTriggersRouteRoute: typeof AuthlayoutSidebarTriggersRouteRouteWithChildren
  AuthlayoutSidebarIndexRoute: typeof AuthlayoutSidebarIndexRoute
  AuthlayoutSidebarApiKeysIndexRoute: typeof AuthlayoutSidebarApiKeysIndexRoute
  AuthlayoutSidebarBrandingIndexRoute: typeof AuthlayoutSidebarBrandingIndexRoute
  AuthlayoutSidebarCoursesIndexRoute: typeof AuthlayoutSidebarCoursesIndexRoute
  AuthlayoutSidebarIntegrationsIndexRoute: typeof AuthlayoutSidebarIntegrationsIndexRoute
  AuthlayoutSidebarMembersIndexRoute: typeof AuthlayoutSidebarMembersIndexRoute
  AuthlayoutSidebarPlanUsageIndexRoute: typeof AuthlayoutSidebarPlanUsageIndexRoute
  AuthlayoutSidebarResourcesIndexRoute: typeof AuthlayoutSidebarResourcesIndexRoute
  AuthlayoutSidebarRolesPermissionsIndexRoute: typeof AuthlayoutSidebarRolesPermissionsIndexRoute
  AuthlayoutSidebarSettingsIndexRoute: typeof AuthlayoutSidebarSettingsIndexRoute
  AuthlayoutSidebarSketchesIndexRoute: typeof AuthlayoutSidebarSketchesIndexRoute
  AuthlayoutSidebarTemplatesIndexRoute: typeof AuthlayoutSidebarTemplatesIndexRoute
  AuthlayoutSidebarTrashIndexRoute: typeof AuthlayoutSidebarTrashIndexRoute
}

const AuthlayoutSidebarLazyRouteChildren: AuthlayoutSidebarLazyRouteChildren = {
  AuthlayoutSidebarDashboardsRouteRoute:
    AuthlayoutSidebarDashboardsRouteRouteWithChildren,
  AuthlayoutSidebarDevicesRouteRoute:
    AuthlayoutSidebarDevicesRouteRouteWithChildren,
  AuthlayoutSidebarThingsRouteRoute:
    AuthlayoutSidebarThingsRouteRouteWithChildren,
  AuthlayoutSidebarTriggersRouteRoute:
    AuthlayoutSidebarTriggersRouteRouteWithChildren,
  AuthlayoutSidebarIndexRoute: AuthlayoutSidebarIndexRoute,
  AuthlayoutSidebarApiKeysIndexRoute: AuthlayoutSidebarApiKeysIndexRoute,
  AuthlayoutSidebarBrandingIndexRoute: AuthlayoutSidebarBrandingIndexRoute,
  AuthlayoutSidebarCoursesIndexRoute: AuthlayoutSidebarCoursesIndexRoute,
  AuthlayoutSidebarIntegrationsIndexRoute:
    AuthlayoutSidebarIntegrationsIndexRoute,
  AuthlayoutSidebarMembersIndexRoute: AuthlayoutSidebarMembersIndexRoute,
  AuthlayoutSidebarPlanUsageIndexRoute: AuthlayoutSidebarPlanUsageIndexRoute,
  AuthlayoutSidebarResourcesIndexRoute: AuthlayoutSidebarResourcesIndexRoute,
  AuthlayoutSidebarRolesPermissionsIndexRoute:
    AuthlayoutSidebarRolesPermissionsIndexRoute,
  AuthlayoutSidebarSettingsIndexRoute: AuthlayoutSidebarSettingsIndexRoute,
  AuthlayoutSidebarSketchesIndexRoute: AuthlayoutSidebarSketchesIndexRoute,
  AuthlayoutSidebarTemplatesIndexRoute: AuthlayoutSidebarTemplatesIndexRoute,
  AuthlayoutSidebarTrashIndexRoute: AuthlayoutSidebarTrashIndexRoute,
}

const AuthlayoutSidebarLazyRouteWithChildren =
  AuthlayoutSidebarLazyRoute._addFileChildren(
    AuthlayoutSidebarLazyRouteChildren,
  )

interface AuthlayoutRouteChildren {
  AuthlayoutSpaceoverviewRouteRoute: typeof AuthlayoutSpaceoverviewRouteRouteWithChildren
  AuthlayoutHeaderLazyRoute: typeof AuthlayoutHeaderLazyRouteWithChildren
  AuthlayoutNoneLazyRoute: typeof AuthlayoutNoneLazyRouteWithChildren
  AuthlayoutSidebarLazyRoute: typeof AuthlayoutSidebarLazyRouteWithChildren
}

const AuthlayoutRouteChildren: AuthlayoutRouteChildren = {
  AuthlayoutSpaceoverviewRouteRoute:
    AuthlayoutSpaceoverviewRouteRouteWithChildren,
  AuthlayoutHeaderLazyRoute: AuthlayoutHeaderLazyRouteWithChildren,
  AuthlayoutNoneLazyRoute: AuthlayoutNoneLazyRouteWithChildren,
  AuthlayoutSidebarLazyRoute: AuthlayoutSidebarLazyRouteWithChildren,
}

const AuthlayoutRouteWithChildren = AuthlayoutRoute._addFileChildren(
  AuthlayoutRouteChildren,
)

interface NoAuthRouteChildren {
  NoAuthMinorsRoute: typeof NoAuthMinorsRoute
  NoAuthAuthFailedIndexRoute: typeof NoAuthAuthFailedIndexRoute
}

const NoAuthRouteChildren: NoAuthRouteChildren = {
  NoAuthMinorsRoute: NoAuthMinorsRoute,
  NoAuthAuthFailedIndexRoute: NoAuthAuthFailedIndexRoute,
}

const NoAuthRouteWithChildren =
  NoAuthRoute._addFileChildren(NoAuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthlayoutRoute: AuthlayoutRouteWithChildren,
  NoAuthRoute: NoAuthRouteWithChildren,
  ChromeAppRoute: ChromeAppRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
